export class GantPoItemVariant {
    size: string;
    quantity: string;
    unitPrice: string;
    description:string;
    shipMode:string;
    deliveryDate:string;
}